// New API to be used for form validation across site

var Validate = {
    isValidName: function (testString) {
        return testString.length >= 2;
    },
    
    isOverMaxLength30: function (testString) {
       
        return testString.length <= 30;

    },
    isOverMaxLength60: function (testString) {
       
        return testString.length <= 60;

    },
    isOverMaxLength20: function (testString) {
        return testString.length <= 20;

    },
    isUnderMinLength2: function (testString) {
        return testString.length < 2;

    },
    isUnderMinLength3: function (testString) {
        return testString.length < 3;

    },
    isOverMaxLength20: function (testString) {
        return testString.length <= 20;

    },
    isValidEmail: function (testString) {
        var regEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(regEx.test(testString)){
            if(testString.indexOf("@-") > 0 || testString.indexOf("-.") > 0){
	    		return false;
	    	}
     	}
         return regEx.test(testString);
    },
    isValidBirthdate: function(inputDateVal) {
        var validDate = false;
        if (inputDateVal != null && inputDateVal != '') {
            var inputDate = new Date(inputDateVal).setHours(0, 0, 0, 0);
            
            var toDay = new Date().setHours(0, 0, 0, 0);
            var oldDate = new Date().setFullYear(1900);
            
            if(inputDate < toDay && inputDate > oldDate){
              validDate = true;
            }
          }

        return validDate;
    },
    isRequired: function (testString) {
        if ($('#email-message').val() == testString)
            return (!/^[a-z A-Z][0-9][!@_*()-:?.,[]#"']/.test(testString) && testString.length > 0);
        else
            return testString.length > 0;
    },
    isValidPhone: function (testString) {
        var containsOnlyNumerics = Validate.stripAllButNumerics(testString).length === testString.length;
        return containsOnlyNumerics && (testString.length === 10);
    },
    isValidQCPhone: function (testString) {
        var containsOnlyNumerics = Validate.stripAllButNumerics(testString).length === testString.length;
        return containsOnlyNumerics && (testString.length === 10);
    },
    isValidCity: function (testString) {
        var cityInput = $("form").find('input[title="Enter a valid city."], input[data-original-title="Enter a valid city."]');
        if (cityInput.length) {
            $.each(cityInput, function () {
                $(this).val($(this).val().replace(/\s\s+/g, ' '));
            });
        }
              
        return testString.length > 2;
    },
    isAddressTwo: function (testString) {
        return !(/[<>{}]/.test(testString));
    },
    isNotZero: function (testString) {
        return (testString !== 0 || testString != "0");
    },
    isBetween8and16chars: function (testString) {
        return testString.length >= 8 && testString.length <= 50;
    },
    isValidResetPasswordPin: function(testString) {
        return testString.length == 6;
    },
    isValidPassword: function (testString) {
        var isGoodLength = Validate.isBetween8and16chars(testString),
            hasNumeric = Validate.stripAllButNumerics(testString).length > 0,
            hasLowerCase = Validate.hasLowerCase(testString),
            hasUpperCase = Validate.hasUpperCase(testString),
            badAsciiCheck = Validate.badAsciiCheck(testString),
            prohibitedCharacters = Validate.prohibitedCharacters(testString);
        return isGoodLength && hasNumeric && hasLowerCase && hasUpperCase && badAsciiCheck && prohibitedCharacters;
    },
    isValidZip: function (testString) {
        //var isAllNumeric = testString === Validate.stripAllButNumerics(testString)
        var isGoodLength = testString.length === 5 || Validate.stripAllButNumerics(testString).length === 9;
        return isGoodLength;
    },
    isValidSku: function (testString) {
        var containsOnlyNumerics = Validate.stripAllButNumerics(testString).length === testString.length;
        return containsOnlyNumerics && (testString.length === 7);
    },
    isValidPasscode: function (testString) {
        var onlyNumbers = (testString === "") ? false : (/^[0-9]*$/.test(testString));
        var goodLength = testString.length == 6;
        return onlyNumbers && goodLength;
    },
    hasANumber: function (testString) {
        return (/[0-9]/g).test(testString);
    },
    hasLowerCase: function (testString) {
        return (/[a-z]/.test(testString));
    },
    hasUpperCase: function (testString) {
        return (/[A-Z]/.test(testString));
    },
    badAsciiCheck: function (testString) {
        return !(/[^\x00-\x7F]|[<>{}]/.test(testString));
    },
    onlyNumbers: function (testString) {
        return (testString === "") ? false : (/^[0-9]*$/.test(testString));
    },
    hasSafeSpecialCharacter: function (input) {
        var filteredValues = "!@#*-_{}.?:;",
            result = "",
            x;
        for (x = 0; x < input.length; x++) {
            var currentChar = input.charAt(x);
            if (filteredValues.indexOf(currentChar) > -1) result += currentChar;
        }
        return result.length > 0;
    },
    prohibitedCharacters: function (input) {
        var filteredValues = "<>{#\\\\`~$\&^=\<>\"|%}';\u20ac\u00a3\u00a5",
            result = "",
            x;
        for (x = 0; x < input.length; x++) {
            var currentChar = input.charAt(x);
            if (filteredValues.indexOf(currentChar) > -1) result += currentChar;
        }
        return result.length < 1;
    },
    stripNonEnglishCharacters: function (input) {
        var result = "",
            x,
            pattern = "[^\\u0000-\\u007F]";
        for (x = 0; x < input.length; x++) {
            var currentChar = input.charAt(x);
            if (currentChar.search(pattern) == -1) result += currentChar;
        }
        if (result.trim() == '') result = '';
        return result;
    },
    stripProhibitedCharacters: function (input, inputPattern) {
        var result = "", x;
        var focusPattern = "0";
        focusPattern = inputPattern;

        // WWW-18510 - stop user from entering more than 1 # at a time 
        var checkHash = 0;
        for (x = 0; x < input.length; x++) {
            var currentChar = input.charAt(x);
            var currentCharAscii = input.charCodeAt(x);
            var lastChar = input.charAt(x-1);
            var lastCharAscii = input.charCodeAt(x-1);
            var twoCharsBack = input.charAt(x-2);
            var twoCharsBackAscii = input.charCodeAt(x-2);
            //iOS smart punctuation characters for apostrophe and single quote
            if (currentCharAscii == '8216' || currentCharAscii == '8217') {
                currentChar = "'";
            }
             //iOS smart punctuation characters for double quotes...(ง'̀-'́)ง darn you ios
            if (currentCharAscii == '8220' || currentCharAscii == '8221') {
                currentChar = '"';
            }
            //only allow 1 # at a time
            if (currentChar == "#") {
                if (lastChar=="#") {
                    currentChar = "";
               }
             }
            if (currentChar.search(focusPattern) > -1) result += currentChar;
        }
        if (result.trim() == '') result = '';
        //remove spaces around / slashes
        if (input.length >= 3) {
            if (currentCharAscii == 47 && lastCharAscii == 32) {_
                result = input.split(" /").join("/");
            }
            if (twoCharsBackAscii == 47 && lastCharAscii == 32) {
                result = input.split("/ ").join("/");
            }
        }

        return result;
    },

    stripServerProhibitedCharactersOnly: function (input) {
        var filteredValues = "<>{}",
            result = "",
            x;

        for (x = 0; x < input.length; x++) {
            var currentChar = input.charAt(x).replace("/", "-");
            if (filteredValues.indexOf(currentChar) === -1) result += currentChar;
        }

        return result;
    },

    stripAllButNumerics: function (input) {
        return input.replace(/[^0-9.]/g, "");
    },
    getPasswordStrength: function (input) {
        if (Validate.isValidPassword(input) && Validate.hasSafeSpecialCharacter(input)) return "Strong";
        else if (Validate.isValidPassword(input)) return "Medium";
        else return "Weak";
    },
};

var doValidate = function (inputField, inputForm) {
        var validateData = $(inputField).data().validate,
            toValidate = validateData.split(','),
            formValue = $.trim($(inputField).val()),
            // add'optional'to the validation to only validate when there is something in the input
            isOptional = (validateData.indexOf('optional') > -1 && formValue.length == 0) ? true : false,																					
            $formParentDiv = $(inputField).parents('.form-group'),
            inputHidden = $(inputField).is(':hidden'),
            isSearchField = $(inputField).hasClass('search-input'),
            isGCaptcha = $(inputField).is('#g-recaptcha-response'),
            flatSizeSelected = $(inputField).find('li.selected').length > 0 ? true : false;

        // Method used in switch to check case
        // NOTE: the !inputVisible check will prevent validation from running on
		// any input fields that are currently hidden!
        // NOTE: added flatSizeSelect so validation will still run on this input
		// even though it's hidden
        var caseCheck = function (validationResult) {
            if ((!validationResult && !isOptional && !inputHidden && !flatSizeSelected) || (!validationResult && isGCaptcha && $('.captchaContainer:visible').length > 0)) {
                $(inputForm).data('validForm', false).data('validFormFailed', true);
                //$('#add-update-address-address-1').val('Test');
                $formParentDiv.addClass('has-error');
 
                if(!isSearchField && !inputForm.is('#emailSignUpModal') && !inputForm.is('#textSignUpModal') && !inputForm.parent().hasClass('product-select-boxes') && !inputForm.parents().hasClass('item-attr-display')) {
                    if ($(inputField).attr('data-original-title') && $(inputField).siblings('p.txt-error').length == 0) {
                        var notValidText = $(inputField).attr('data-original-title');
                        if (notValidText !== undefined && !$(inputField).is('#g-recaptcha-response')){
                            var theIdDescribedBy = $(inputField).attr('name') + '-error-message';
                            $(inputField).attr('aria-describedby', theIdDescribedBy);
                            $("<p class='help-block txt-error' id='" + theIdDescribedBy + "' tabindex='0'>" + notValidText + "</p>").insertAfter(inputField);
                            $("<span class='sr-only'>" + notValidText + "</span>").insertAfter(inputField);
                        }
                    } else if ($(inputField).siblings('p.txt-error').length == 0){
                        var notValidText = $(inputField).attr('title');
                        if (notValidText !== undefined && !$(inputField).is('#g-recaptcha-response')){
                            var theIdDescribedBy = $(inputField).attr('name') + '-error-message';
                            $(inputField).attr('aria-describedby', theIdDescribedBy);
                            $("<p class='help-block txt-error' id='" + theIdDescribedBy + "'>" + notValidText + "</p>").insertAfter(inputField);
                            $("<span class='sr-only'>" + notValidText + "</span>").insertAfter(inputField);
                        }
                    }
                }
                else if(isSearchField) {
                    if ($(inputField).attr('data-original-title') && $(inputField).siblings('p.txt-error').length == 0) {
                        var notValidText = $(inputField).attr('data-original-title');
                        if (notValidText !== undefined)	$('.search-input').attr('placeholder','Enter a valid search term');
                    } else if ($(inputField).siblings('p.txt-error').length == 0){
                        var notValidText = $(inputField).attr('title');
                        if (notValidText !== undefined) $('.search-input').attr('placeholder','Enter a valid search term');
                    }  
                }

                var gResponse = $('#g-recaptcha-response');

                 if (!isSearchField){
                     $(inputField).data('fieldValid', false);
                 }
            } else {
                $(inputForm).data('validForm', true).data('validFormFailed', false);
                if ($(inputField).data('tooltip')) {
                    // $(inputField).tooltip('destroy').data('fieldValid', true);
                    $(inputField).data('fieldValid', true);
                } else {
                    if ($(inputField).hasClass('flat') && $(inputField).parent().hasClass('invalidSelection')) {
                        $(inputField).data('fieldValid', false);
                    } else {
                        $(inputField).data('fieldValid', true);
                    }
                }
                $(inputField).removeAttr('aria-describedby').siblings('.tooltip, p.txt-error, span.sr-only').remove();
            }
        };

        $.each(toValidate, function (val) {
            // This checks if 'min' or max 'validation' is present
            var lengthCase = ((toValidate[val].indexOf('min') > -1) || (toValidate[val].indexOf('max') > -1)) || false;
            // This checks if 'matches' validation is present
            var matchesCase = toValidate[val].indexOf('matches') > -1 || false;
            // This checks if minValue or maxValue 'validation' is present
            var valueCase = ((toValidate[val].indexOf('minValue') > -1) || (toValidate[val].indexOf('maxValue') > -1)) || false;
           
            if (!lengthCase && !matchesCase && !valueCase) {
                switch (toValidate[val].trim()) {
                    // Add new validation names for use on te 'data-validate'
					// attribute as needed.
                    // The caseCheck() method is expecting a true or false. Use
					// any method you would like to check the forms value, as
					// long as it returns a boolen.
                    
                    case "dob":
                        caseCheck(Validate.isValidBirthdate(formValue));
                        break;     
                    case "maxLength(30)":
                        caseCheck(Validate.isOverMaxLength30(formValue));
                        break;
                    case "maxLength(20)":
                        caseCheck(Validate.isOverMaxLength20(formValue));    
                        break;    
                    case "maxLength(60)":
                        caseCheck(Validate.isOverMaxLength60(formValue));    
                        break;   
                    case "minLength(2)":
                        caseCheck(Validate.isUnderMinLength2(formValue));    
                        break; 
                    case "minLength(3)":
                        caseCheck(Validate.isUnderMinLength3(formValue));    
                        break;     
                    case "email":
                        caseCheck(Validate.isValidEmail(formValue) && Validate.prohibitedCharacters(formValue));
                        break;
                    case "phone":
                        caseCheck(Validate.isValidPhone(formValue.replace(/[-()\s]/g, "")));
                        break;
                    case "quick-checkout-phone":
                        caseCheck(Validate.isValidQCPhone(formValue.replace(/[-()\s]/g, "")));
                        break;
                    case "zip":
                        caseCheck(Validate.isValidZip(formValue));
                        break;
                    case "city":
                        caseCheck(Validate.isValidCity(formValue.replace(/\s\s+/g, ' ')));
                        break;
                    case "isAddressTwo":
                        caseCheck(Validate.isAddressTwo(formValue.toLowerCase()));
                        break;    
                    case "password":
                        // The 12 *'s are here because password fields, when
						// there is a password on record, are populated with 12
						// *'s
                        // This input value will be passed as 'valid.' This may
						// be inportant to note in regards to form submits and
						// back-end validation
                        (formValue != "************") ? caseCheck(Validate.isValidPassword(formValue) && Validate.prohibitedCharacters(formValue)): caseCheck(true);
                        break;
                    case "name":
                        caseCheck(Validate.isValidName(formValue));
                        break;
                    case "required":
                        caseCheck(Validate.isRequired(formValue.toLowerCase()));
                        break;
                    case "hasLowerCase":
                        caseCheck(Validate.hasLowerCase(formValue));
                        break;
                    case "hasUpperCase":
                        caseCheck(Validate.hasUpperCase(formValue));
                        break;
                    case "isNotZero":
                        caseCheck(Validate.isNotZero(formValue));
                        break;
                    case "onlyNumbers":
                        caseCheck(Validate.onlyNumbers(formValue));
                        break;
                    case "isValidSku":
                        caseCheck(Validate.isValidSku(formValue));
                        break;
                    case "passcode":
                        caseCheck(Validate.isValidPasscode(formValue));
                        break;
                    default:
                        break;
                }
            }
            // This validation is for 'minValue' and 'maxValue' validation
            if (!$(inputForm).data('validFormFailed') && valueCase) {
                var theNumber = parseInt(toValidate[val].match(/\([^)]+/g)[0].substring(1)),
                    isANumber = Validate.onlyNumbers(formValue);
                if (!isANumber || formValue === "") caseCheck(false);
                else {
                    if (toValidate[val].indexOf('max') > -1)(parseInt(formValue, 10) > parseInt(theNumber, 10)) ? caseCheck(false) : caseCheck(true);
                    if (toValidate[val].indexOf('min') > -1)(parseInt(formValue, 10) < parseInt(theNumber, 10)) ? caseCheck(false) : caseCheck(true);
                }
            }
            $('.plusQty, .minusQty').on('click', function () {
                $(this).parent().removeClass('has-error');
            });
            // This validation is for 'min' and 'max' validation
            if (!$(inputForm).data('validFormFailed') && lengthCase && !valueCase) {
                var theNumber = parseInt(toValidate[val].match(/\([^)]+/g)[0].substring(1));
                if (toValidate[val].indexOf('max') > -1)(theNumber < formValue.length) ? caseCheck(false) : caseCheck(true);
                if (toValidate[val].indexOf('min') > -1)(theNumber > formValue.length) ? caseCheck(false) : caseCheck(true);
            }
            // This validation is for 'matches' validation
            if (matchesCase) {
                var theInput = toValidate[val].match(/\([^)]+/g)[0].substring(1),
                    theInputVal = $('#' + theInput).val();
                if (theInput == 'logonId') {
                    if (theInputVal !== undefined)(formValue.toLowerCase() != theInputVal.toLowerCase()) ? caseCheck(false) : caseCheck(true);
                } else {
                    if (theInputVal !== undefined)(formValue != theInputVal) ? caseCheck(false) : caseCheck(true);
                }
            }
        });

        if ($('#emailSignUpModal .emailInput').hasClass('has-error')) {
          // ADA error label for email signup
          if ($('#emailError').length == 0) {
            $('<div id="emailError" class="email-input-error" for="recipientEmail" tabindex="-1">Please enter a valid email</div>').insertAfter('.footerSubmit');
          }
        };
        if ($('#textSignUpModal .textInput').hasClass('has-error')) {
            if ($('#textError').length == 0) {
              $('<div id="textError" class="text-input-error" for="recipientText" tabindex="-1">Please enter a valid phone number</div>').insertAfter('.textFooterSubmit');
            }
          };
      };

var formValidation = () => {
    if ($('[data-mask]').length > 0) {
        $('[data-mask]').each(function () {
            var $this = $(this),
                maskVal = $this.attr('data-mask');
            $this.mask(maskVal);
        });
    };

    var $zipInput = $('form').find('#zipcode, #zipcode1, #zipcode2, #zipcode3, #postalCode');
    $zipInput.on('keydown', function(num){
      var $keyCode = num.keyCode;
      if (!($keyCode == 86 && (num.ctrlKey === true || num.metaKey === true)) // allows
																				// ctl
																				// v
          && !($keyCode == 65 && (num.ctrlKey === true || num.metaKey === true))// allows
																				// ctl
																				// a
          && !($keyCode == 67 && (num.ctrlKey === true || num.metaKey === true))// allows
																				// ctl
																				// c
          && $keyCode != 46 // allows delete
          && $keyCode != 37 // allows left arrow
          && $keyCode != 39 // allows right arrow
          && $keyCode > 31 && ($keyCode < 48 || $keyCode > 57 && $keyCode < 96 || $keyCode > 105)) return false; // doesn't
																													// allow
																													// for
																													// letters

          if (($keyCode >= 48 && $keyCode <= 57) && num.shiftKey == true) return false;// don't
																						// allow
																						// shiftKey
																						// with
																						// numbers

          return true;
    });

    // Selects all forms on the page. Add 'data-novalidation' to a form to NOT
	// validate it.
    // This will also omit forms that do not have any inputs that need to be
	// validated
    var $allForms = $("form").not('*[data-novalidation]').has('input[data-validate],text-area[data-validate],select[data-validate], textarea[data-validate]');
    // Main validator method
    // Passes in the input field to validate and the parent form it belongs to
    
    // Set binds to all forms and form inputs
    $.each($allForms.not('#orderReviewForm'), function(){
        validateThisForm(this);
    });
};

function validateThisForm(that) {

        // If check below checks if there is already any data on the form. If so
		// it skips the following binds.
        // This is necessary so the formValidation method can be called after
		// page load (for example, when a dynamic modal is loaded).
    if ($(that).data('validForm') === undefined) {
            // Queries all inputs and textareas that have the 'data-validate'
			// data attribute.

        var $formInputs = $(that).find('input[data-validate], textarea[data-validate], select[data-validate]'),
            theForm = $(that),
                theFormID = theForm.attr('id');

            // Adds the 'validForm' data to the form, sets it as false.
            // This data attribute reflects if the form HAS failed validation.
			// It's much better to use 'validForm' when checking if a form is
			// valid!!
            theForm.data('validFormFailed', false).data('validForm', false);
            $formInputs.on('input',function () {
                // Resets error and success when a user re-focuses on an input.
				// Removes tool-tip.
                // $(this).siblings('p.txt-error').remove();
                // $(this).parents('.form-group').removeClass('has-error');
                theForm.data('validForm', false).data('validFormFailed', false);

            });

            $('#recipientEmail').on('input', function () {
                if (($(that).attr('id') == 'emailSignUpModal') && $(this).val().length || ($(this).data('validate').indexOf('optional') > -1)) {
                    $('#emailError').remove();
                }
            });

            $('#recipientText').on('input', function () {
                if (($(that).attr('id') == 'emailSignUpModal') && $(this).val().length || ($(this).data('validate').indexOf('optional') > -1)) {
                    $('#textError').remove();
                }
            });

        $formInputs.on('input change', function () {

                 // the following is for find registry. if exists, else skip
                    if ($(this).attr('id') === 'reg_find_first_name' || $(this).attr('id') === 'reg_find_last_name' || $(this).attr('id') === 'reg_find_registry_number') {
                        const inputId = $(this).attr('id');
                        if (inputId === 'reg_find_first_name' || inputId === 'reg_find_last_name') {
                            // if length is > 0
                            const field = $(this);
                            const value = $(field).val();
                            const findRegByNumField = $('#reg_find_registry_number')[0];
                            const parent = $(findRegByNumField).parent()[0];
                            const otherFieldValue = $(field).attr('id') === 'reg_find_first_name' ? $("#reg_find_last_name").val() : $("#reg_find_first_name").val();
                            if (value.length > 0 || otherFieldValue.length > 0) {
                                // disable and remove required
                                $(findRegByNumField).removeAttr('data-validate');
                                findRegByNumField.setAttribute('disabled', '');
                                $(findRegByNumField).removeAttr('aria-describedby').siblings('p.txt-error, span.sr-only').remove();
                                $(findRegByNumField).parents('.form-group').removeClass('has-error');
                                $(parent).removeClass('required');
                            } else {
                                // otherwise put it back where you found it!
                                findRegByNumField.removeAttribute('disabled')
                                $(parent).addClass('required');
                                $(findRegByNumField).attr('data-validate', 'required,min(9),max(9),onlyNumbers');
                                // add it back
                            }
                            
                        } else {
                            const field = $(this);
                            const value = $(field).val();
                            const findRegFirstName = $('#reg_find_first_name')[0];
                            const findRegLastName = $('#reg_find_last_name')[0];
                            const firstNameParent = $(findRegFirstName).parent()[0];
                            const lastNameParent =  $(findRegLastName).parent()[0];
                            if (value.length > 0) {
                                // disable and remove required
                                findRegFirstName.setAttribute('disabled', '');
                                findRegLastName.setAttribute('disabled', '');
                                $(firstNameParent).removeClass('required');
                                $(lastNameParent).removeClass('required');
                                $(findRegFirstName).removeAttr('data-validate');
                                $(findRegLastName).removeAttr('data-validate');
                                $(findRegFirstName).removeAttr('aria-describedby').siblings('p.txt-error, span.sr-only').remove();
                                $(findRegFirstName).parents('.form-group').removeClass('has-error');
                                $(findRegLastName).removeAttr('aria-describedby').siblings('p.txt-error, span.sr-only').remove();
                                $(findRegLastName).parents('.form-group').removeClass('has-error');
                                // remove required from data-validate
                            } else {
                                // otherwise put it back where you found it!
                                findRegFirstName.removeAttribute('disabled');
                                findRegLastName.removeAttribute('disabled');
                                $(firstNameParent).addClass('required');
                                $(lastNameParent).addClass('required');
                                $(findRegFirstName).attr('data-validate', 'required,name,min(2)');
                                $(findRegLastName).attr('data-validate', 'required,name,min(2)');
                                // add it back
                            }
                        }
                    }



                // Validates field on blur. Resets stopFormSubmit so validation
				// will run again when submit is clicked.
                    if ($(this).val().length || ($(this).data('validate').indexOf('optional') > -1)){
                        
                        $(this).removeAttr('aria-describedby').siblings('p.txt-error, span.sr-only').remove();
                        $(this).parents('.form-group').removeClass('has-error');
                        doValidate(this, theForm);
                    } 
                    else {
                        theForm.data('validForm', false);
                        $(this).data('fieldValid', false);
                    }

            });

            // This places the buttons 'onclick' attribute in a data attribute
			// so it is not called until form is valid
            // To prevent this add the data-novalidation attribute
            var addErrorVisuals = function (shopperActions, isQV) {
                    let isShopTheOutfit = $('.outfit-display-page').length > 0,
                        outfitShopperActions = shopperActions.parents('.shopper_action_wrapper'),
                        isMobile = $('.mobilePage').length > 0;
                    $.each(shopperActions.find('button, a').not('*[data-novalidation]'), function () {
                        var $this = $(this);
                        if ($this.attr('onclick')) $this.data('theOnClick', $this.attr('onclick')).attr('onclick', '');
                    });
                    shopperActions.find('button, a, input[type="submit"]').not('*[data-novalidation]').on('click.finalValidation', function (event) {
                        theForm.data('validForm', false);
                        // Prevents the form from submitting until checked by
						// validation
                        event.preventDefault();
                        // A final check is done on all the submitted form's
						// fields and selects.
                        $.each(theForm.find('input[data-validate], textarea[data-validate], select[data-validate], ul[data-validate]'), function () {
                            doValidate(this, theForm);
                        });
                        // Throw a error message above each ADD TO BAG button
                        var theFormHasErrors = theForm.find('.form-group.has-error').length > 0,
                            shopperActionsExist = isQV ? shopperActions.length > 0 : shopperActions.find('.shopper-actions').length > 0,
                            qvScroll = $('.modal-quickview .q-view-scroll');
                        const removeExistingPopover = (container) => {
                            container.find('.popover-wrapper').remove();
                            container.removeAttr('aria-describedby').find('.txt-error').remove();
                        };
                        const setPopoverWrapper = (container) => {
                            return container.find('.popover-wrapper');
                        }
                        const setPopoverContent = (container, array) => {
                            container.find('.popover-content-error').html(array);
                        }
                        if (isQV) {
                            removeExistingPopover(qvScroll);
                        } else if (isShopTheOutfit && !isMobile) {
                            removeExistingPopover(outfitShopperActions);
                        } else {
                            // removeExistingPopover(shopperActions);
                        }
                        // If the form has errors and the you're in a modal and
						// you have description expanded...scroll to see error.
                        if (theFormHasErrors === true && $(".modal-body .panel-collapse.collapse.in").length > 0) {
                            let $panelOpen = $(".modal-body .panel-collapse.collapse.in");
                            $panelOpen.siblings('.panel-heading').children('.panel-title').children('a').addClass('collapsed');
                            $panelOpen.removeClass('in');
                        }
                        if (theFormHasErrors && shopperActionsExist) {
                            $.each(theForm, function () {
                                var popoverTemplate = ['<div class="popover-error" role="tooltip">',
                                        '<div class="popover-content-error" role="status" aria-live="polite"></div>',
                                        '</div>'
                                    ].join(''),
                                    notValidArray = [];
                                let popoverShell = '<div class="popover-wrapper"></div>';
                                if (isQV) {
                                    $(popoverShell).insertAfter('.modal-quickview .product-select-boxes');
                                } else if (isShopTheOutfit && !isMobile) {
                                    $(popoverShell).insertAfter('.outfit-display-page .product-select-boxes');
                                } else {
                                    $(popoverShell).insertBefore(shopperActions.find('.shopper-actions'));
                                }
                                theForm.find('.form-group.has-error [data-validate]').each(function (index, element) {
                                    var notValidText = $(this).data('original-title');
                                    var errorMessage = "<span class='popover-error' role='status' aria-live='polite'>" + "( " + notValidText + " )" + "</span>"
                                    if (notValidText !== undefined) notValidArray.push(notValidText);
                                    if ($(element).hasClass('color-select')) {
                                      $(element).siblings('.popover-error').remove();
                                      $(errorMessage).insertAfter($(element).siblings('label'));
                                    }
                                    if ($('ul.size-select-flat').length == 0 && $('.dynamicModalContainer').length == 0 ) {
                                        if ($(element).hasClass('size-select')) {
                                            $(element).siblings('.popover-error').remove();
                                            $(errorMessage).insertAfter($(element).siblings('label'));
                                        }
                                    }
                                    if ($(element).hasClass('amount-select')) {
                                        $(element).siblings('.popover-error').remove();
                                        $(errorMessage).insertAfter($(element).siblings('label'));
                                      }
                                    if ($('.dynamicModalContainer ').length > 0) {
                                      // Size Error for Quick View
                                      if ($(element).hasClass('size-select') && $(element).parent().hasClass('size-select-group')) {
                                        $(element).siblings('.popover-error').remove();
                                        $(errorMessage).insertAfter($(element).siblings('label'));
                                      }
                                    }

                                    if ($('ul.size-select-flat').length > 0 && $('.dynamicModalContainer').length == 0 ) {
                                      if ($(element).hasClass('size-select')) {
                                        $('ul.size-select-flat').siblings('.popover-error').remove();
                                        $(errorMessage).insertAfter($('.size-select-group-flat label'));

                                        if ($('ul.size-select-flat li.size-selected').length > 0) {
                                          $('ul.size-select-flat li.size-selected').addClass('flat-size-error');
                                        }
                                      }
                                    }

                                    if ($('.q-view-content ul.size-select-flat').length > 0 && $('.mobilePage .dynamicModalContainer').length > 0) {
                                        if ($(element).hasClass('size-select')) {
                                            $('.q-view-content ul.size-select-flat').siblings('.popover-error').remove();
                                            $(errorMessage).insertAfter($('.size-select-group-flat-qv label'));

                                            if ($('.size-select-group-flat-qv ul.size-select-flat li.size-selected').length > 0) {
                                              $('.size-select-group-flat-qv ul.size-select-flat li.size-selected').addClass('flat-size-error');
                                            }
                                        }
                                    }
                                });

                                var getNotValidArray = notValidArray.map(function (v) {
                                        return `${v}<br>`;
                                    }),
                                    popOverWrapper = '';
                                if (isQV) {
                                    popOverWrapper = setPopoverWrapper(qvScroll);
                                } else if (isShopTheOutfit && !isMobile) {
                                    popOverWrapper = setPopoverWrapper(outfitShopperActions);
                                } else {
                                    popOverWrapper = setPopoverWrapper(shopperActions);
                                }
                                // $(popoverTemplate).prependTo(popOverWrapper)
                                if (isQV) {
                                    setPopoverContent(qvScroll, getNotValidArray);
                                } else if (isShopTheOutfit && !isMobile) {
                                    setPopoverContent(outfitShopperActions, getNotValidArray);
                                } else {
                                    // setPopoverContent(shopperActions,
									// getNotValidArray);
                                }
                            });
                        }

                        // $.each(theForm, function () {
                        //     if(!theForm.is('#emailSignUpModal') && !theForm.parent().hasClass('product-select-boxes') && !theForm.parents().hasClass('item-attr-display')) {
                        //         theForm.find('.form-group.has-error [data-validate]').each(function (index, element) {
                        //             var input = $(this);
                        //             var notValidText = $(input).attr('data-original-title');
                        //             var errorId = $(input).attr('name')
                        //             if (notValidText !== undefined && !$(input).is('#g-recaptcha-response')) $("<p id='" + errorId +"-has-error' class='help-block txt-error' tabindex='0'>" + notValidText + "</p>").insertAfter(input);
                        //             $(input).attr('aria-describedby', errorId +'-error-message');
                        //         });
                        //     }
                        // });

                        $('.help-block').on("click", function() {
                            $(this).siblings('input').focus();
                          });

                        $('.has-error').find('p.help-block').first().focus();

                        $('p.help-block').on("keydown", function(num) {
                            if(num.keyCode == 13) {
                              num.preventDefault();
                              $(this).trigger("click");
                            }
                          });
                          
                        if ($('#g-recaptcha-response').length > 0 && $(this).parents('form').data('recaptcha') === undefined && $(this).parents('form').find('#g-recaptcha-response').length > 0) {
                            $('#g-recaptcha-response').attr('data-validate', 'required');
                            $('#g-recaptcha-response').attr('data-original-title', 'You must check the box to continue.');

                            // add Special error text and border for Google recaptcha V2
                            $.each(theForm, function () {
                                var captchaNotChecked = $('#g-recaptcha-response').data('original-title');
                                var errorGCaptcha = $('#gcaptcha div').first();
                                if (captchaNotChecked != undefined && $('#captchaCheckError').length == 0) {
                                    $('#gcaptcha').append("<p id='captchaCheckError' class='help-block txt-error'>" + captchaNotChecked + "</p>");
                                    $('.isGcaptcha').addClass('has-error');
                                    errorGCaptcha.css('border', '1px solid #a94442');
                                    errorGCaptcha.attr('aria-describedby', 'captchaCheckError');
                                } 
                                // Removes error text and border
                                if ($('#g-recaptcha-response').val().length > 0) {
                                    var gResponse = $('#g-recaptcha-response');
                                    $('#gcaptcha').find('p.txt-error').remove();
                                    $('.isGcaptcha').removeClass('has-error');
                                    errorGCaptcha.css('border', '');
                                    errorGCaptcha.removeAttr('aria-describedby', 'captchaCheckError');
                                    $('#g-recaptcha-response').removeClass('has-error').data('fieldValid', true);
                                };
                            });
                        }

                        // Are all the inputs valid?
                        var inputValid = true;
                        $.each(theForm.find('*[data-validate]'), function () {
                            if (inputValid && !$(this).data('fieldValid')) {
                                inputValid = false;
                                // This scrolls user to the first failed input
                                if ($(this).parents('.modal-body').length <= 0) { // Prevents
																					// auto-scroll
																					// when
																					// form
																					// is
																					// in a
																					// modal
                                  if (!$(this).hasClass('size-select') && theForm[0].id.indexOf("contest") < 0) {
                                    $('body,html').animate({
                                        scrollTop: $(this).offset().top - 200
                                    }, 500);
                                  } else if ($(this).hasClass('size-select') && $(this).parents('.size-select-group').siblings().hasClass('size-select-group-flat')) {
                                    $('body,html').animate({
                                        scrollTop: $('.size-select-group-flat').offset().top - 200
                                    }, 500);
                                  } else if ($(this).hasClass('size-select') && !$(this).parents('.size-select-group').siblings().hasClass('size-select-group-flat')) {
                                    $('body,html').animate({
                                        scrollTop: $(this).offset().top - 200
                                    }, 500);
                                  };
                                //   $(this)[0].focus();
                                }
                            }
                        });
                        if($('.has-error input:visible').length > 0) $('.has-error input:visible')[0].focus();
                        // Force phone numbers to numbers only (requires
						// type="phone")
                        var phoneInputs = theForm.find('input[type="tel"]');
                        if (phoneInputs.length) {
                            $.each(phoneInputs, function () {
                                $(this).val($(this).val().replace(/[-()\s]/g, ""));
                            });
                        }
                        // Submits the form if all fields are valid
                        if (inputValid && $(this).attr('type') == 'submit') theForm.submit();
                        // If the form is valid and has an onclick it will
						// re-add the onclick method and trigger it
                        if ($(this).data('theOnClick') && $(theForm).data('validForm') && inputValid) {
                            var clickMethod = $(this).data('theOnClick');
                            $(this).attr('onclick', clickMethod).removeData('theOnClick').trigger('click');
                        }

                    });
                },
                altImgClickValidation = function () {
                    $('.alt-image-tile').on('click', function () {
                        if ($('.color-select-group').hasClass('has-error')) $('.color-select-group').removeClass('has-error');
                    });
                    $('.form-group').on('mouseover focus', function () {
                        if (!$(this).hasClass('has-error')) $(this).find('.tooltip').not(".captchaSpeakerTooltip + .tooltip").hide();
                    });
                };
            if (theForm.find('input[data-validate], textarea[data-validate], select[data-validate]').length) {
                var isQV = $('.modal-quickview').length > 0,
                    inventoryOHOOForm = $("#inventoryOHOOForm").length > 0,
                    shopperActionsQV = $('.modal-quickview .shopper-actions');
                if (inventoryOHOOForm || !isQV) addErrorVisuals(theForm, isQV);
                else if (isQV) addErrorVisuals(shopperActionsQV, isQV);
                // Sprint 69 #7209
                altImgClickValidation();
                $.each($formInputs, function () {
                    if (this.value) doValidate(this, theForm);
                    if ($(this).data().validate.indexOf('optional') > -1) $(this).data('fieldValid', true);
                });
            }
        }
}



export {
    Validate,
    formValidation,
    validateThisForm
}
